<template>
  <v-card flat>
    <v-toolbar>
      <!-- <h3 class="headline mb-0">Detalii</h3> -->
      <v-toolbar-title>Detalii</v-toolbar-title>

      <v-spacer></v-spacer>

      <v-btn icon flat color="blue-grey" @click="_cbResetAll" :ripple="false" :disabled="user.dummy">
        <v-icon>mdi-close</v-icon>
      </v-btn>

      <v-spacer></v-spacer>

      <!-- <v-scale-transition> -->
        <v-btn icon flat color="blue-grey" v-show="isEdited" @click="_cbUndoAll" :ripple="false" :disabled="user.dummy">
          <v-icon>mdi-undo</v-icon>
        </v-btn>
        <v-spacer></v-spacer>
      <!-- </v-scale-transition> -->
      <!-- <v-scale-transition> -->
        <v-btn icon flat color="blue-grey" v-show="isEdited" @click="save" :ripple="false" :disabled="user.dummy">
          <v-icon>mdi-content-save</v-icon>
        </v-btn>
        <v-spacer></v-spacer>
      <!-- </v-scale-transition> -->
      <!-- <v-spacer></v-spacer> -->
      <!-- <v-scale-transition> -->
        <!-- <v-progress-circular
          indeterminate
          size="18"
          width="2"
          color="blue-grey"
          v-show="loading">
        </v-progress-circular> -->
      <!-- </v-scale-transition> -->
      <v-btn icon flat color="blue-grey" @click.stop="_cbOpenSettings" :ripple="false">
        <v-icon>mdi-settings</v-icon>
      </v-btn>
    </v-toolbar>
    <v-card-text class="pa-1" v-if="entityObject">
      <v-card class="mb-2" v-if="visibleFields.includes('info adresa')">
        <v-card-title class="accent--text title">Info adresa / poi</v-card-title>
        <v-divider color="accent"></v-divider>
        <v-card-text class="pa-1">
          <v-card class="mb-3">
            <v-system-bar window class="px-1">ID</v-system-bar>
            <v-card-text class="pa-1">
              <v-text-field
                :value="entityObject._id"
                hint="ID in baza de date, folosit doar de catre aplicatie"
                disabled
                persistent-hint
                solo flat>
              </v-text-field>
            </v-card-text>
          </v-card>

          <v-card class="mb-3">
            <v-system-bar window class="px-1">
              Eticheta &nbsp;
              <v-btn class="pa-0 ma-0 ml-1" small flat icon v-if="isFieldEdited('eticheta')" @click="undo('eticheta')" :ripple="false">
                <v-icon small>mdi-undo</v-icon>
              </v-btn>
            </v-system-bar>
            <v-card-text class="pa-1">
              <v-select
                :items="labels"
                hint="Folosita la gruparea simbolurilor / poi-urilor in calupuri. Editabil doar de catre admin."
                v-model="entityObject.eticheta"
                :item-text="etichetaText"
                item-value="label"
                :disabled="!user.admin"
                persistent-hint
                :menu-props="{transition: false}"
                solo flat>
              </v-select>
            </v-card-text>
          </v-card>
          <v-card class="mb-3">
            <v-system-bar window class="px-1">
              Zona &nbsp;
              <v-btn class="pa-0 ma-0 ml-1" small flat icon v-if="isFieldEdited('zona')" @click="undo('zona')" :ripple="false">
                <v-icon small>mdi-undo</v-icon>
              </v-btn>
            </v-system-bar>
            <v-card-text class="pa-1">
              <v-select
                :items="zones"
                hint="Folosita la gruparea simbolurilor / poi-urilor in zone. Editabil doar de catre admin."
                v-model="entityObject.zona"
                :item-text="zonaText"
                item-value="zona"
                :disabled="!user.admin"
                persistent-hint
                :menu-props="{transition: false}"
                solo flat>
              </v-select>
            </v-card-text>
          </v-card>

          <v-card class="mb-3">
            <v-system-bar window class="px-1">
              ID Scara &nbsp;
              <v-btn class="pa-0 ma-0 ml-1" small flat icon v-if="isFieldEdited('id_scara')" @click="undo('id_scara')" :ripple="false">
                <v-icon small>mdi-undo</v-icon>
              </v-btn>
            </v-system-bar>
            <v-card-text class="pa-1">
              <v-text-field
                @input="setField($event, 'id_scara')"
                :value="entityObject.id_scara"
                hint="ID in xlsx, folosit pentru a identifica in mod unic adresa / poi-ul. Editabil doar de catre admin."
                :disabled="!user.admin"
                persistent-hint
                append-icon="mdi-refresh"
                @click:append="refreshIdScara"
                validate-on-blur
                :rules="[val => !!val || 'Camp obligatoriu!']"
                solo flat>
              </v-text-field>
            </v-card-text>
          </v-card>

          <v-card class="mb-3">
            <v-system-bar window class="px-1">
              Adresa &nbsp;
              <v-btn class="pa-0 ma-0 ml-1" small flat icon v-if="isFieldEdited('adresa')" @click="undo('adresa')" :ripple="false">
                <v-icon small>mdi-undo</v-icon>
              </v-btn>
            </v-system-bar>
            <v-card-text class="pa-1">
              <v-text-field
                @input="setField($event, 'adresa')"
                :value="entityObject.adresa"
                hint="Adresa asociata poi-ului. Editabil de catre admin sau de catre user-ul care a adaugat poi-ul."
                :disabled="!user.admin && entityObject.addedBy !== user.username"
                persistent-hint
                validate-on-blur
                :rules="[val => !!val || 'Camp obligatoriu!']"
                solo flat>
              </v-text-field>
            </v-card-text>
          </v-card>

          <v-card class="mb-3">
            <v-system-bar window class="px-1">
              <v-icon small color="error" style="margin-right: 0" @click="resetField('observatii_adresa')">mdi-close</v-icon>

              Observatii adresa &nbsp;
              <v-btn class="pa-0 ma-0 ml-1" small flat icon v-if="isFieldEdited('observatii_adresa')" @click="undo('observatii_adresa')" :ripple="false">
                <v-icon small>mdi-undo</v-icon>
              </v-btn>
            </v-system-bar>
            <v-card-text class="pa-1">
              <v-textarea
                @input="setField($event, 'observatii_adresa')"
                :value="entityObject.observatii_adresa"
                auto-grow
                :rows="1"
                hide-details
                hint="Observatii la adresa."
                persistent-hint
                solo flat>
              </v-textarea>
            </v-card-text>
          </v-card>

          <v-card class="mb-3">
            <v-system-bar window class="px-1">
              <v-icon small color="error" style="margin-right: 0" @click="resetField('observatii')">mdi-close</v-icon>

              Observatii &nbsp;
              <v-btn class="pa-0 ma-0 ml-1" small flat icon v-if="isFieldEdited('observatii')" @click="undo('observatii')" :ripple="false">
                <v-icon small>mdi-undo</v-icon>
              </v-btn>
            </v-system-bar>
            <v-card-text class="pa-1">
              <v-textarea
                @input="setField($event, 'observatii')"
                :value="entityObject.observatii"
                auto-grow
                :rows="1"
                hide-details
                hint="Observatii generale."
                persistent-hint
                solo flat>
              </v-textarea>
            </v-card-text>
          </v-card>

          <v-card class="mb-3">
            <v-system-bar window class="px-1">
              <v-icon small color="error" style="margin-right: 0" @click="resetField('done')">mdi-close</v-icon>
              Done &nbsp;
              <v-btn class="pa-0 ma-0 ml-1" small flat icon v-if="isFieldEdited('done')" @click="undo('done')" :ripple="false">
                <v-icon small>mdi-undo</v-icon>
              </v-btn>
            </v-system-bar>
            <v-card-text class="pa-1">
              <v-radio-group
                row
                v-model="entityObject.done"
                hint="S-a incheiat procesarea acestei adrese / acestui poi?"
                persistent-hint
                :disabled="user.dummy">
                <v-radio label="Da" :value="true" :ripple="false"></v-radio>
                <v-radio label="Nu" :value="false" :ripple="false"></v-radio>
              </v-radio-group>
            </v-card-text>
          </v-card>

          <v-card class="mb-3">
            <v-system-bar window class="px-1">
              Centru geometric &nbsp;
              <v-btn class="pa-0 ma-0 ml-1" small flat icon v-if="isFieldEdited('centru_geometric')" @click="undo('centru_geometric')" :ripple="false">
                <v-icon small>mdi-undo</v-icon>
              </v-btn>
            </v-system-bar>
            <v-card-text class="pa-1">
              <div style="width: 100%; height: 40vh">
                <GmapMap
                  :center="entityObject.centru_geometric"
                  :zoom="zoom"
                  :map-type-id="mapType"
                  :style="{ width: options.width, height: options.height }"
                  ref="map"
                  @zoom_changed="zoomChanged"
                  @maptypeid_changed="mapTypeChanged">

                  <GmapMarker
                    :position="entityObject.centru_geometric"
                    :draggable="!user.dummy"
                    @dragend="_cbDragEnd" />

                </GmapMap>
              </div>
            </v-card-text>
          </v-card>
        </v-card-text>
      </v-card>

      <v-card class="mb-2" v-if="visibleFields.includes('info scara blocului')">
        <v-card-title class="accent--text title">Info scara blocului</v-card-title>
        <v-divider color="accent"></v-divider>
        <v-card-text class="pa-1">
          <v-card class="mb-3">
            <v-system-bar window class="px-1">
              <v-icon small color="error" style="margin-right: 0" @click="resetField('comert_servicii', 'info_scara_blocului')">mdi-close</v-icon>

              Comert servicii &nbsp;
              <v-btn class="pa-0 ma-0 ml-1" small flat icon v-if="isFieldEdited('comert_servicii', 'info_scara_blocului')" @click="undo('comert_servicii', 'info_scara_blocului')" :ripple="false">
                <v-icon small>mdi-undo</v-icon>
              </v-btn>
            </v-system-bar>
            <v-card-text class="pa-1">
              <v-radio-group
                row
                v-model="entityObject.info_scara_blocului.comert_servicii"
                hint="Exista spatii pentru comert/servicii?"
                persistent-hint
                :disabled="user.dummy">
                <v-radio label="Da" value="Da" :ripple="false"></v-radio>
                <v-radio label="Nu" value="Nu" :ripple="false"></v-radio>
              </v-radio-group>
            </v-card-text>
          </v-card>

          <v-card class="mb-3">
            <v-system-bar window class="px-1">
              <v-icon small color="error" style="margin-right: 0" @click="resetField('etaj_tehnic_vizibil', 'info_scara_blocului')">mdi-close</v-icon>

              Etaj tehnic vizibil &nbsp;
              <v-btn class="pa-0 ma-0 ml-1" small flat icon v-if="isFieldEdited('etaj_tehnic_vizibil', 'info_scara_blocului')" @click="undo('etaj_tehnic_vizibil', 'info_scara_blocului')" :ripple="false">
                <v-icon small>mdi-undo</v-icon>
              </v-btn>
            </v-system-bar>
            <v-card-text class="pa-1">
              <v-radio-group
                row
                v-model="entityObject.info_scara_blocului.etaj_tehnic_vizibil"
                hint="Etajul tehnic este vizibil?"
                persistent-hint
                :disabled="user.dummy">
                <v-radio label="Da" value="Da" :ripple="false"></v-radio>
                <v-radio label="Nu" value="Nu" :ripple="false"></v-radio>
              </v-radio-group>
            </v-card-text>
          </v-card>

          <v-card class="mb-3">
            <v-system-bar window class="px-1">
              <v-icon small color="error" style="margin-right: 0" @click="resetField('nr_apartamente_pe_scara', 'info_scara_blocului')">mdi-close</v-icon>

              Nr apartamenete pe scara &nbsp;
              <v-btn class="pa-0 ma-0 ml-1" small flat icon v-if="isFieldEdited('nr_apartamente_pe_scara', 'info_scara_blocului')" @click="undo('nr_apartamente_pe_scara', 'info_scara_blocului')" :ripple="false">
                <v-icon small>mdi-undo</v-icon>
              </v-btn>
            </v-system-bar>
            <v-card-text class="pa-1">
              <v-text-field
                @input="setField($event, 'nr_apartamente_pe_scara', 'info_scara_blocului', null, true)"
                :value="entityObject.info_scara_blocului.nr_apartamente_pe_scara"
                hint="Numar apartamente pe scara."
                type="number"
                @wheel="onWheel"
                persistent-hint
                :min="1"
                :max="150"
                validate-on-blur
                :rules="[val => val !== null || 'Camp obligatoriu!', val => (val >=1 && val <= 150) || 'Valoarea introdusa nu se incadreaza in intervalul [1, 150].']"
                solo flat
                :disabled="user.dummy">
              </v-text-field>
            </v-card-text>
          </v-card>

          <v-card class="mb-3">
            <v-system-bar window class="px-1">
              <v-icon small color="error" style="margin-right: 0" @click="resetField('nr_niveluri_comert_servicii', 'info_scara_blocului')">mdi-close</v-icon>

              Niveluri comert &nbsp;
              <v-btn :disabled="entityObject.info_scara_blocului.comert_servicii === 'Nu'" small flat icon v-if="isFieldEdited('nr_niveluri_comert_servicii', 'info_scara_blocului')" @click="undo('nr_niveluri_comert_servicii', 'info_scara_blocului')" :ripple="false">
                <v-icon small>mdi-undo</v-icon>
              </v-btn>
            </v-system-bar>
            <v-card-text class="pa-1">
              <v-radio-group
                row
                v-model="entityObject.info_scara_blocului.nr_niveluri_comert_servicii"
                hint="Nr niveluri comert/servicii."
                persistent-hint
                :disabled="entityObject.info_scara_blocului.comert_servicii === 'Nu' || user.dummy">
                <v-radio label="1" :value="1" :ripple="false"></v-radio>
                <v-radio label="2" :value="2" :ripple="false"></v-radio>
                <v-radio label="3" :value="3" :ripple="false"></v-radio>
              </v-radio-group>
            </v-card-text>
          </v-card>

          <v-card class="mb-3">
            <v-system-bar window class="px-1">
              <v-icon small color="error" style="margin-right: 0" @click="resetField('nr_niveluri_vizibile', 'info_scara_blocului')">mdi-close</v-icon>

              Nr niveluri vizibile &nbsp;
              <v-btn class="pa-0 ma-0 ml-1" small flat icon v-if="isFieldEdited('nr_niveluri_vizibile', 'info_scara_blocului')" @click="undo('nr_niveluri_vizibile', 'info_scara_blocului')" :ripple="false">
                <v-icon small>mdi-undo</v-icon>
              </v-btn>
            </v-system-bar>
            <v-card-text class="pa-1">
              <v-text-field
                @input="setField($event, 'nr_niveluri_vizibile', 'info_scara_blocului', null, true)"
                :value="entityObject.info_scara_blocului.nr_niveluri_vizibile"
                hint="Nr niveluri vizibile."
                persistent-hint
                type="number"
                @wheel="onWheel"
                :min="3"
                :max="18"
                validate-on-blur
                :rules="[val => ![null, ''].includes(val) || 'Camp obligatoriu!', val => (val >= 3 && val <= 18) || 'Valoarea introdusa nu se incadreaza in intervalul [3, 18].']"
                solo flat
                :disabled="user.dummy">
              </v-text-field>
            </v-card-text>
          </v-card>

          <v-card class="mb-3">
            <v-system-bar window class="px-1">
              <v-icon small color="error" style="margin-right: 0" @click="resetField('reabilitat', 'info_scara_blocului')">mdi-close</v-icon>

              Reabilitat &nbsp;
              <v-btn class="pa-0 ma-0 ml-1" small flat icon v-if="isFieldEdited('reabilitat', 'info_scara_blocului')" @click="undo('reabilitat', 'info_scara_blocului')" :ripple="false">
                <v-icon small>mdi-undo</v-icon>
              </v-btn>
            </v-system-bar>
            <v-card-text class="pa-1">
              <v-radio-group
                row
                v-model="entityObject.info_scara_blocului.reabilitat"
                hint="Reabilitat?"
                persistent-hint
                :disabled="user.dummy">
                <v-radio label="Da" value="Da" :ripple="false"></v-radio>
                <v-radio label="Nu" value="Nu" :ripple="false"></v-radio>
              </v-radio-group>
            </v-card-text>
          </v-card>

          <v-card class="mb-3">
            <v-system-bar window class="px-1">
              Regim inaltime &nbsp;
            </v-system-bar>
            <v-card-text class="pa-1">
              <v-text-field
                :value="entityObject.info_scara_blocului.regim_inaltime"
                hint="Regim inaltime. Camp calculat automat pe baza datelor de mai sus."
                persistent-hint
                disabled
                readonly
                class="mb-3"
                solo flat>
              </v-text-field>
            </v-card-text>
          </v-card>

          <v-card class="mb-3">
            <form ref="formscara">
              <input type="file" ref="fileinputscara" accept="image/*" multiple @change="filesAdded($event, 'scara')" style="display: none">
            </form>
            <v-system-bar window class="px-1">
              Poze scara &nbsp;
              <div style="display: inline-flex; flex-grow: 1; flex-wrap: wrap; align-items: center">
                <template>
                  <v-icon class="ml-1" color="primary" title="Poze incarcate">mdi-camera</v-icon>
                  {{noOfEntityPhotos}}
                </template>
                <template>
                  <v-btn class="ma-0 ml-1 pa-0" icon flat @click.stop.prevent style="min-width: 0" :ripple="false">
                    <v-icon :color="entityFilesInQueue ? 'primary' : 'blue-grey'" class="mr-1" title="Poze in asteptare">mdi-cloud-upload</v-icon>
                    {{ entityFilesInQueue }}
                  </v-btn>

                  <v-spacer></v-spacer>
                  <v-btn small class="ma-0" icon flat @click.stop.prevent="_cbAddPhoto('scara')" v-if="user && !user.dummy" color="primary" :ripple="false">
                    <v-icon class="mr-0">mdi-plus-circle</v-icon>
                  </v-btn>

                  <!-- mark bad photos -->
                  <v-btn small class="ma-0" icon flat @click.stop.prevent="_cbToggleBadMode" v-if="!user.dummy" :ripple="false">
                    <v-icon :color="badEnabled ? 'warning' : 'blue-grey'" class="mr-0">mdi-alert</v-icon>
                  </v-btn>
                  <v-btn small class="ma-0" icon flat @click.stop.prevent="_cbConfirmBad" v-show="badEnabled && toBad.length" :ripple="false">
                    <v-icon color="warning" class="mr-0">mdi-check-circle</v-icon>
                  </v-btn>

                  <!-- delete photos -->
                  <v-btn small class="ma-0" icon flat @click.stop.prevent="_cbToggleDeleteMode" v-if="!user.dummy" :ripple="false">
                    <v-icon :color="deleteEnabled ? 'error' : 'blue-grey'" class="mr-0">mdi-delete-circle</v-icon>
                  </v-btn>
                  <v-btn small class="ma-0" icon flat @click.stop.prevent="_cbConfirmDelete" v-show="deleteEnabled && toDelete.length" :ripple="false">
                    <v-icon color="error" class="mr-0">mdi-check-circle</v-icon>
                  </v-btn>
                  <span v-show="deleteEnabled && toDelete.length">
                    {{toDelete.length}}
                  </span>

                </template>
              </div>
            </v-system-bar>
            <v-card-text class="pa-1">
              <template v-if="noOfEntityPhotos">
                <viewer v-if="!deleteEnabled && !badEnabled" :options="{url: 'data-src', backdrop: 'static'}">
                  <template>
                    <v-layout align-center justify-flex-start wrap>
                      <div style="display: flex; flex-wrap: wrap">
                        <template v-for="(photo, pIndex) in scaraPhotos">
                          <div style="display: flex; flex-direction: column; align-items: center; width: 64px" :key="photo + pIndex">
                            <v-avatar
                              size="48"
                              class="ma-1 viewerPhoto"
                              style="box-sizing: border-box">
                              <img
                                :src="serverURL + photo.replace('photos', 'thumbs')"
                                :data-src="serverURL + photo"
                                class="pa-1">
                            </v-avatar>
                            <div style="display: flex; justify-content: space-around; width: 100%">
                              <a :href="serverURL + photo + '?buster=' + new Date().getTime()" download target="_blank" style="text-decoration: none" title="Descarca poza">
                                <v-icon small>mdi-download</v-icon>
                              </a>
                              <v-icon small color="warning" v-if="photo.includes('_badphoto')">mdi-alert</v-icon>
                              <a :href="serverURL + photo + '?buster=' + new Date().getTime()" target="_blank" style="text-decoration: none" title="Deschide poza intr-un tab nou">
                                <v-icon small>mdi-eye</v-icon>
                              </a>
                            </div>
                          </div>
                        </template>
                      </div>
                    </v-layout>
                  </template>
                </viewer>
                <v-layout v-if="deleteEnabled" align-center justify-flex-start wrap>
                  <!-- <v-scale-transition group> -->
                  <template v-for="(photo, pIndex) in scaraPhotos">
                    <div style="display: flex; flex-direction: column; align-items: center; width: 64px" :key="photo + pIndex">
                      <v-avatar
                        size="48"
                        class="ma-1"
                        :class="{ 'deletePhoto': toDelete.includes(photo), 'normalPhoto': !toDelete.includes(photo) }"
                        style="box-sizing: border-box"
                        @click="selectPhoto(photo)">
                        <img
                          :src="serverURL + photo.replace('photos', 'thumbs')"
                          :data-src="serverURL + photo"
                          class="pa-1">
                      </v-avatar>
                      <v-icon small color="warning" v-if="photo.includes('_badphoto')">mdi-alert</v-icon>
                    </div>
                  </template>
                  <!-- </v-scale-transition> -->
                </v-layout>
                <v-layout v-if="badEnabled" align-center justify-flex-start wrap>
                  <!-- <v-scale-transition group> -->
                  <template v-for="(photo, pIndex) in scaraPhotos">
                    <div style="display: flex; flex-direction: column; align-items: center; width: 64px" :key="photo + pIndex">
                      <v-avatar
                        size="48"
                        class="ma-1"
                        :class="{ 'badPhoto': toBad.includes(photo), 'normalPhoto': !toBad.includes(photo) }"
                        style="box-sizing: border-box"
                        @click="selectBadPhoto(photo)">
                        <img
                          :src="serverURL + photo.replace('photos', 'thumbs')"
                          :data-src="serverURL + photo"
                          class="pa-1">
                      </v-avatar>
                      <v-icon small color="warning" v-if="photo.includes('_badphoto')">mdi-alert</v-icon>
                    </div>
                  </template>
                  <!-- </v-scale-transition> -->
                </v-layout>
              </template>
              <template v-else>
                Nu exista poze pentru scara.
              </template>
            </v-card-text>
          </v-card>

          <v-card class="mb-3">
            <form ref="pdfformscara">
              <input type="file" ref="pdffileinputscara" accept="application/pdf" multiple @change="pdfsAdded($event, 'scara')" style="display: none">
            </form>
            <v-system-bar window class="px-1">
              PDF-uri scara &nbsp;
              <div style="display: inline-flex; flex-grow: 1; flex-wrap: wrap; align-items: center">
                <template>
                  <v-icon class="ml-1" color="primary" title="Pdf-uri incarcate">mdi-file-pdf</v-icon>
                  {{noOfEntityPdfs}}
                </template>
                <template>
                  <v-btn class="ma-0 ml-1 pa-0" icon flat @click.stop.prevent style="min-width: 0" :ripple="false">
                    <v-icon :color="entityPdfsInQueue ? 'primary' : 'blue-grey'" class="mr-1" title="Pdf-uri in asteptare">mdi-cloud-upload</v-icon>
                    {{ entityPdfsInQueue }}
                  </v-btn>

                  <v-spacer></v-spacer>
                  <v-btn class="ma-0" icon flat @click.stop.prevent="_cbAddPdf('scara')" v-if="user && user.admin" color="primary" :ripple="false">
                    <v-icon>mdi-plus-circle</v-icon>
                  </v-btn>

                  <v-btn class="ma-0" icon flat @click.stop.prevent="_cbToggleDeletePdfsMode" v-if="user.admin" :ripple="false">
                    <v-icon :color="deletePdfsEnabled ? 'error' : 'blue-grey'">mdi-delete-circle</v-icon>
                  </v-btn>
                  <v-btn class="ma-0" icon flat @click.stop.prevent="_cbConfirmDeletePdfs" v-show="deletePdfsEnabled && toDeletePdfs.length" :ripple="false">
                    <v-icon color="error">mdi-check-circle</v-icon>
                  </v-btn>
                  <span v-show="deletePdfsEnabled && toDeletePdfs.length">
                    {{toDeletePdfs.length}}
                  </span>

                </template>
              </div>
            </v-system-bar>
            <v-card-text class="pa-1">
              <template v-if="noOfEntityPdfs">
                <template v-if="!deletePdfsEnabled">
                  <v-layout align-center justify-flex-start wrap>
                    <div style="display: flex; flex-wrap: wrap">
                      <template v-for="(pdf, pIndex) in scaraPdfs">
                        <div style="display: flex; flex-direction: column; align-items: center; width: 64px" :key="pdf + pIndex">
                          <v-avatar
                            color="primary"
                            size="48"
                            class="ma-1"
                            style="box-sizing: border-box">
                            <v-icon class="pa-1">mdi-file-pdf</v-icon>
                          </v-avatar>
                          <span class="text-no-wrap text-truncate" style="width: 64px; text-align: center" :title="pdf">{{ pdf.replace('/pdfs/', '') }}</span>
                          <div style="display: flex; justify-content: space-around; width: 100%">
                            <a :href="serverURL + pdf + '?buster=' + new Date().getTime()" download target="_blank" style="text-decoration: none" title="Descarca pdf">
                              <v-icon small>mdi-download</v-icon>
                            </a>
                            <a @click.stop="viewPdf(pdf, serverURL + pdf + '?buster=' + new Date().getTime())" style="text-decoration: none" title="Deschide pdf">
                              <v-icon small>mdi-eye</v-icon>
                            </a>
                          </div>
                        </div>
                      </template>
                    </div>
                  </v-layout>
                </template>
                <template v-else>
                  <v-layout align-center justify-flex-start wrap>
                    <div style="display: flex; flex-wrap: wrap">
                      <template v-for="(pdf, pIndex) in scaraPdfs">
                        <div style="display: flex; flex-direction: column; align-items: center; width: 64px" :key="pdf + pIndex">
                          <v-avatar
                            :color="toDeletePdfs.includes(pdf) ? 'error' : ''"
                            size="48"
                            :key="pdf + pIndex"
                            class="ma-1"
                            :class="{ 'deletePdf': toDeletePdfs.includes(pdf), 'normalPdf': !toDeletePdfs.includes(pdf) }"
                            style="box-sizing: border-box"
                            @click="selectPdf(pdf)">
                            <v-icon class="pa-1">
                              mdi-file-pdf
                            </v-icon>
                          </v-avatar>
                          <span :key="pdf + pIndex + 'pdf'" class="text-no-wrap text-truncate" style="width: 64px; text-align: center" :title="pdf">{{ pdf.replace('/pdfs/', '') }}</span>
                        </div>
                      </template>
                    </div>
                  </v-layout>
                </template>
              </template>
              <template>
                Nu exista pdf-uri.
              </template>
            </v-card-text>
          </v-card>
        </v-card-text>
      </v-card>

      <v-card class="mb-2" v-if="visibleFields.includes('info consum')">
        <v-card-title class="accent--text title">Info consum</v-card-title>
        <v-divider color="accent"></v-divider>
        <v-card-text class="pa-1">
          <v-card class="mb-3">
            <v-system-bar window class="px-1">
              <v-icon small color="error" style="margin-right: 0" @click="resetField('exista_info', 'info_consum')">mdi-close</v-icon>

              Exista info despre consum? &nbsp;
              <v-btn class="pa-0 ma-0 ml-1" small flat icon v-if="isFieldEdited('exista_info', 'info_consum')" @click="undo('exista_info', 'info_consum')" :ripple="false">
                <v-icon small>mdi-undo</v-icon>
              </v-btn>
            </v-system-bar>
            <v-card-text class="pa-1">
              <v-radio-group
                row
                v-model="entityObject.info_consum.exista_info"
                hint="Exista informatii despre consum?"
                persistent-hint
                :disabled="user.dummy">
                <v-radio label="Da" value="Da" :ripple="false"></v-radio>
                <v-radio label="Nu" value="Nu" :ripple="false"></v-radio>
              </v-radio-group>
            </v-card-text>
          </v-card>

          <v-card class="mb-3">
            <v-system-bar window class="px-1">
              <v-icon small color="error" style="margin-right: 0" @click="resetField('consum_curent_lift_avizier', 'info_consum')">mdi-close</v-icon>

              Consum curent lift avizier &nbsp;
              <v-btn class="pa-0 ma-0 ml-1" small flat icon v-if="isFieldEdited('consum_curent_lift_avizier', 'info_consum')" @click="undo('consum_curent_lift_avizier', 'info_consum')" :ripple="false">
                <v-icon small>mdi-undo</v-icon>
              </v-btn>
            </v-system-bar>
            <v-card-text class="pa-1">
              <v-text-field
                @input="setField($event, 'consum_curent_lift_avizier', 'info_consum', null, true)"
                :value="entityObject.info_consum.consum_curent_lift_avizier"
                type="number"
                @wheel="onWheel"
                hint="Consum curent lift afisat la avizier."
                persistent-hint
                :disabled="entityObject.info_consum.exista_info === 'Nu' || user.dummy"
                validate-on-blur
                :rules="[val => entityObject.info_consum.exista_info === 'Da' ? ![null, ''].includes(val) || 'Camp obligatoriu!' : true]"
                solo flat>
              </v-text-field>
            </v-card-text>
          </v-card>

          <v-card class="mb-3">
            <v-system-bar window class="px-1">
              <v-icon small color="error" style="margin-right: 0" @click="resetField('consum_curent_lift_avizier_unitate_masura', 'info_consum')">mdi-close</v-icon>

              Consum curent lift avizier unitate masura &nbsp;
              <v-btn class="pa-0 ma-0 ml-1" small flat icon v-if="isFieldEdited('consum_curent_lift_avizier_unitate_masura', 'info_consum')" @click="undo('consum_curent_lift_avizier_unitate_masura', 'info_consum')" :ripple="false">
                <v-icon small>mdi-undo</v-icon>
              </v-btn>
            </v-system-bar>
            <v-card-text class="pa-1">
              <v-radio-group
                row
                v-model="entityObject.info_consum.consum_curent_lift_avizier_unitate_masura"
                hint="Consum curent lift avizier unitate masura."
                persistent-hint
                :disabled="entityObject.info_consum.exista_info === 'Nu' || user.dummy">
                <v-radio label="lei" value="lei" :ripple="false"></v-radio>
                <v-radio label="kWh/luna" value="kWh/luna" :ripple="false"></v-radio>
              </v-radio-group>
            </v-card-text>
          </v-card>

          <v-card class="mb-3">
            <v-system-bar window class="px-1">
              <v-icon small color="error" style="margin-right: 0" @click="resetField('consum_curent_spatii_comune_avizier', 'info_consum')">mdi-close</v-icon>

              Consum curent spatii comune avizier &nbsp;
              <v-btn class="pa-0 ma-0 ml-1" small flat icon v-if="isFieldEdited('consum_curent_spatii_comune_avizier', 'info_consum')" @click="undo('consum_curent_spatii_comune_avizier', 'info_consum')" :ripple="false">
                <v-icon small>mdi-undo</v-icon>
              </v-btn>
            </v-system-bar>
            <v-card-text class="pa-1">
              <v-text-field
                @input="setField($event, 'consum_curent_spatii_comune_avizier', 'info_consum', null, true)"
                :value="entityObject.info_consum.consum_curent_spatii_comune_avizier"
                type="number"
                @wheel="onWheel"
                hint="Consum curent spatii comune afisat la avizier."
                persistent-hint
                :disabled="entityObject.info_consum.exista_info === 'Nu' || user.dummy"
                validate-on-blur
                :rules="[val => entityObject.info_consum.exista_info === 'Da' ? ![null, ''].includes(val) || 'Camp obligatoriu!' : true]"
                solo flat>
              </v-text-field>
            </v-card-text>
          </v-card>

          <v-card class="mb-3">
            <v-system-bar window class="px-1">
              <v-icon small color="error" style="margin-right: 0" @click="resetField('consum_curent_spatii_comune_avizier_unitate_masura', 'info_consum')">mdi-close</v-icon>

              Consum curent sp. com. avizier u.m. &nbsp;
              <v-btn class="pa-0 ma-0 ml-1" small flat icon v-if="isFieldEdited('consum_curent_spatii_comune_avizier_unitate_masura', 'info_consum')" @click="undo('consum_curent_spatii_comune_avizier_unitate_masura', 'info_consum')" :ripple="false">
                <v-icon small>mdi-undo</v-icon>
              </v-btn>
            </v-system-bar>
            <v-card-text class="pa-1">
              <v-radio-group
                row
                v-model="entityObject.info_consum.consum_curent_spatii_comune_avizier_unitate_masura"
                hint="Consum curent spatii comune avizier unitate masura."
                persistent-hint
                :disabled="entityObject.info_consum.exista_info === 'Nu' || user.dummy">
                <v-radio label="lei" value="lei" :ripple="false"></v-radio>
                <v-radio label="kWh/luna" value="kWh/luna" :ripple="false"></v-radio>
              </v-radio-group>
            </v-card-text>
          </v-card>
        </v-card-text>
      </v-card>

      <v-card class="mb-2" v-if="visibleFields.includes('info lift')">
        <v-card-title class="accent--text title">Info lift/lifturi</v-card-title>
        <v-divider color="accent"></v-divider>
        <v-card-text class="pa-1">

          <v-card class="mb-3">
            <v-system-bar window class="px-1">
              <v-icon small color="error" style="margin-right: 0" @click="resetField('nr_lift_scara')">mdi-close</v-icon>

              Nr lift scara &nbsp;
              <v-btn class="pa-0 ma-0 ml-1" small flat icon v-if="isFieldEdited('nr_lift_scara')" @click="undo('nr_lift_scara')" :ripple="false">
                <v-icon small>mdi-undo</v-icon>
              </v-btn>
            </v-system-bar>
            <v-card-text class="pa-1">
              <v-radio-group
                row
                v-model="entityObject.nr_lift_scara"
                hint="Nr lifturi pe scara."
                persistent-hint
                :disabled="user.dummy">
                <v-radio label="0" :value="0" :ripple="false"></v-radio>
                <v-radio label="1" :value="1" :ripple="false"></v-radio>
                <v-radio label="2" :value="2" :ripple="false"></v-radio>
                <v-radio label="3" :value="3" :ripple="false"></v-radio>
              </v-radio-group>
            </v-card-text>
          </v-card>

          <v-tabs color="transparent" slider-color="accent" hide-slider v-if="entityObject.nr_lift_scara">
            <v-tab
              v-for="n in entityObject.nr_lift_scara"
              :key="n"
              :ripple="false">
              Lift {{ n }}
            </v-tab>

            <v-tab-item
              v-for="n in entityObject.nr_lift_scara"
              :key="n"
              :transition="false"
              :reverse-transition="false">
              <v-card flat>
                <v-card-text class="pa-0">

                  <v-card class="mb-3">
                    <v-system-bar window class="px-1">
                      <v-icon small color="error" style="margin-right: 0" @click="resetField('tip_put', 'info_lift', n-1)">mdi-close</v-icon>

                      Structura gol usa &nbsp;<span class="accent--text">lift {{n}}</span>
                      <v-btn class="pa-0 ma-0 ml-1" small flat icon v-if="isFieldEdited('tip_put', 'info_lift', n-1)" @click="undo('tip_put', 'info_lift', n-1)" :ripple="false">
                        <v-icon small>mdi-undo</v-icon>
                      </v-btn>
                      <div style="display: inline-flex; flex-grow: 1; flex-wrap: wrap; align-items: center" v-if="n-1">
                        <v-spacer></v-spacer>
                        <v-btn :ripple="false" class="pa-0 ma-0" style="min-width: 20px" small flat @click="copyInfo('tip_put', n-1)">
                          <v-icon small left>mdi-plus-circle-multiple-outline</v-icon>
                          <span style="text-transform: none; max-width: 3.5em" class="text-truncate">{{entityObject.info_lift[n-2]['tip_put']}}</span>
                        </v-btn>
                      </div>
                    </v-system-bar>
                    <v-card-text class="pa-1">
                      <v-radio-group
                        row
                        v-model="entityObject.info_lift[n -1].tip_put"
                        hint="Tip put."
                        persistent-hint
                        :disabled="user.dummy">
                        <v-radio label="beton" value="beton" :ripple="false"></v-radio>
                        <v-radio label="metal" value="metal" :ripple="false"></v-radio>
                      </v-radio-group>
                    </v-card-text>
                  </v-card>

                  <v-card class="mb-3">
                    <v-system-bar window class="px-1">
                      <v-icon small color="error" style="margin-right: 0" @click="resetField('tip_deschidere_usa_put', 'info_lift', n-1)">mdi-close</v-icon>

                      Tip deschidere usa &nbsp;<span class="accent--text">lift {{n}}</span>
                      <v-btn class="pa-0 ma-0 ml-1" small flat icon v-if="isFieldEdited('tip_deschidere_usa_put', 'info_lift', n-1)" @click="undo('tip_deschidere_usa_put', 'info_lift', n-1)" :ripple="false">
                        <v-icon small>mdi-undo</v-icon>
                      </v-btn>
                      <div style="display: inline-flex; flex-grow: 1; flex-wrap: wrap; align-items: center" v-if="n-1">
                        <v-spacer></v-spacer>
                        <v-btn :ripple="false" class="pa-0 ma-0" style="min-width: 20px" small flat @click="copyInfo('tip_deschidere_usa_put', n-1)">
                          <v-icon left small>mdi-plus-circle-multiple-outline</v-icon>
                          <span style="text-transform: none; max-width: 3.5em" class="text-truncate">{{entityObject.info_lift[n-2]['tip_deschidere_usa_put']}}</span>
                        </v-btn>
                      </div>
                    </v-system-bar>
                    <v-card-text class="pa-1">
                      <v-radio-group
                        row
                        v-model="entityObject.info_lift[n -1].tip_deschidere_usa_put"
                        hint="Tip deschidere usa put."
                        persistent-hint
                        :disabled="user.dummy">
                        <v-radio label="manuala" value="manuala" :ripple="false"></v-radio>
                        <v-radio label="semiautomata" value="semiautomata" :ripple="false"></v-radio>
                        <v-radio label="automata" value="automata" :ripple="false"></v-radio>
                      </v-radio-group>
                    </v-card-text>
                  </v-card>

                  <v-card class="mb-3">
                    <v-system-bar window class="px-1">
                      <v-icon small color="error" style="margin-right: 0" @click="resetField('exista_info_capacitate', 'info_lift', n-1)">mdi-close</v-icon>

                      Exista info capacitate &nbsp;<span class="accent--text">lift {{n}}?</span> &nbsp;
                      <v-btn class="pa-0 ma-0 ml-1" small flat icon v-if="isFieldEdited('exista_info_capacitate', 'info_lift', n-1)" @click="undo('exista_info_capacitate', 'info_lift', n-1)" :ripple="false">
                        <v-icon small>mdi-undo</v-icon>
                      </v-btn>
                      <div style="display: inline-flex; flex-grow: 1; flex-wrap: wrap; align-items: center" v-if="n-1">
                        <v-spacer></v-spacer>
                        <v-btn :ripple="false" class="pa-0 ma-0" style="min-width: 20px" small flat @click="copyInfo('exista_info_capacitate', n-1)">
                          <v-icon small left>mdi-plus-circle-multiple-outline</v-icon>
                          <span style="text-transform: none; max-width: 3.5em" class="text-truncate">{{entityObject.info_lift[n-2]['exista_info_capacitate']}}</span>
                        </v-btn>
                      </div>
                    </v-system-bar>
                    <v-card-text class="pa-1">
                      <v-radio-group
                        row
                        v-model="entityObject.info_lift[n -1].exista_info_capacitate"
                        hint="Exista informatii despre capacitate?"
                        persistent-hint
                        :disabled="user.dummy">
                        <v-radio label="Da" value="Da" :ripple="false"></v-radio>
                        <v-radio label="Nu" value="Nu" :ripple="false"></v-radio>
                      </v-radio-group>
                    </v-card-text>
                  </v-card>

                  <v-card class="mb-3">
                    <v-system-bar window class="px-1">
                      <v-icon small color="error" style="margin-right: 0" @click="resetField('capacitate_cabina_persoane', 'info_lift', n-1)">mdi-close</v-icon>

                      Capacitate cabina (pers.) &nbsp;<span class="accent--text">lift {{n}}</span>
                      <v-btn class="pa-0 ma-0 ml-1" small flat icon v-if="isFieldEdited('capacitate_cabina_persoane', 'info_lift', n-1)" @click="undo('capacitate_cabina_persoane', 'info_lift', n-1)" :ripple="false">
                        <v-icon small>mdi-undo</v-icon>
                      </v-btn>
                      <div style="display: inline-flex; flex-grow: 1; flex-wrap: wrap; align-items: center" v-if="n-1">
                        <v-spacer></v-spacer>
                        <v-btn :ripple="false" class="pa-0 ma-0" style="min-width: 20px" small flat @click="copyInfo('capacitate_cabina_persoane', n-1)">
                          <v-icon small left>mdi-plus-circle-multiple-outline</v-icon>
                          <span style="text-transform: none; max-width: 3.5em" class="text-truncate">{{entityObject.info_lift[n-2]['capacitate_cabina_persoane']}}</span>
                        </v-btn>
                      </div>
                    </v-system-bar>
                    <v-card-text class="pa-1">
                      <v-text-field
                        @input="setField($event, 'capacitate_cabina_persoane', 'info_lift', n-1, true)"
                        :value="entityObject.info_lift[n-1].capacitate_cabina_persoane"
                        type="number"
                        @wheel="onWheel"
                        hint="Capacitate cabina (persoane)."
                        persistent-hint
                        :disabled="entityObject.info_lift[n-1].exista_info_capacitate === 'Nu' || user.dummy"
                        validate-on-blur
                        :rules="[val => entityObject.info_lift[n-1].exista_info_capacitate === 'Da' ? ![null, ''].includes(val) || 'Camp obligatoriu!' : true]"
                        solo flat>
                      </v-text-field>
                    </v-card-text>
                  </v-card>

                  <v-card class="mb-3">
                    <v-system-bar window class="px-1">
                      <v-icon small color="error" style="margin-right: 0" @click="resetField('capacitate_cabina_kg', 'info_lift', n-1)">mdi-close</v-icon>

                      Capacitate cabina (kg) &nbsp;<span class="accent--text">lift {{n}}</span>
                      <v-btn class="pa-0 ma-0 ml-1" small flat icon v-if="isFieldEdited('capacitate_cabina_kg', 'info_lift', n-1)" @click="undo('capacitate_cabina_kg', 'info_lift', n-1)" :ripple="false">
                        <v-icon small>mdi-undo</v-icon>
                      </v-btn>
                      <div style="display: inline-flex; flex-grow: 1; flex-wrap: wrap; align-items: center" v-if="n-1">
                        <v-spacer></v-spacer>
                        <v-btn :ripple="false" class="pa-0 ma-0" style="min-width: 20px" small flat @click="copyInfo('capacitate_cabina_kg', n-1)">
                          <v-icon small left>mdi-plus-circle-multiple-outline</v-icon>
                          <span style="text-transform: none; max-width: 3.5em" class="text-truncate">{{entityObject.info_lift[n-2]['capacitate_cabina_kg']}}</span>
                        </v-btn>
                      </div>
                    </v-system-bar>
                    <v-card-text class="pa-1">
                      <v-text-field
                        @input="setField($event, 'capacitate_cabina_kg', 'info_lift', n-1, true)"
                        :value="entityObject.info_lift[n -1].capacitate_cabina_kg"
                        type="number"
                        @wheel="onWheel"
                        hint="Capacitate cabina (kg)."
                        persistent-hint
                        :disabled="entityObject.info_lift[n -1].exista_info_capacitate === 'Nu' || user.dummy"
                        validate-on-blur
                        :rules="[val => entityObject.info_lift[n -1].exista_info_capacitate === 'Da' ? ![null, ''].includes(val) || 'Camp obligatoriu!' : true]"
                        solo flat>
                      </v-text-field>
                    </v-card-text>
                  </v-card>

                  <v-card class="mb-3">
                    <v-system-bar window class="px-1">
                      <v-icon small color="error" style="margin-right: 0" @click="resetField('stare_cabina', 'info_lift', n-1)">mdi-close</v-icon>

                      Stare cabina &nbsp;<span class="accent--text">lift {{n}}</span>
                      <v-btn class="pa-0 ma-0 ml-1" small flat icon v-if="isFieldEdited('stare_cabina', 'info_lift', n-1)" @click="undo('stare_cabina', 'info_lift', n-1)" :ripple="false">
                        <v-icon small>mdi-undo</v-icon>
                      </v-btn>
                      <div style="display: inline-flex; flex-grow: 1; flex-wrap: wrap; align-items: center" v-if="n-1">
                        <v-spacer></v-spacer>
                        <v-btn :ripple="false" class="pa-0 ma-0" style="min-width: 20px" small flat @click="copyInfo('stare_cabina', n-1)">
                          <v-icon small left>mdi-plus-circle-multiple-outline</v-icon>
                          <span style="text-transform: none; max-width: 3.5em" class="text-truncate">{{entityObject.info_lift[n-2]['stare_cabina']}}</span>
                        </v-btn>
                      </div>
                    </v-system-bar>
                    <v-card-text class="pa-1">
                      <v-radio-group
                        row
                        v-model="entityObject.info_lift[n -1].stare_cabina"
                        hint="Stare cabina."
                        persistent-hint
                        :disabled="user.dummy">
                        <v-radio label="veche" value="veche" :ripple="false"></v-radio>
                        <v-radio label="placata/schimbata" value="placata/schimbata" :ripple="false"></v-radio>
                      </v-radio-group>
                    </v-card-text>
                  </v-card>

                  <v-card class="mb-3">
                    <v-system-bar window class="px-1">
                      <v-icon small color="error" style="margin-right: 0" @click="resetField('nr_statii_butoniera', 'info_lift', n-1)">mdi-close</v-icon>

                      Nr statii butoniera &nbsp;<span class="accent--text">lift {{n}}</span>
                      <v-btn class="pa-0 ma-0 ml-1" small flat icon v-if="isFieldEdited('nr_statii_butoniera', 'info_lift', n-1)" @click="undo('nr_statii_butoniera', 'info_lift', n-1)" :ripple="false">
                        <v-icon small>mdi-undo</v-icon>
                      </v-btn>
                      <v-spacer></v-spacer>
                      <div style="display: inline-flex; flex-grow: 1; flex-wrap: wrap; align-items: center" v-if="n-1">
                        <v-spacer></v-spacer>
                        <v-btn :ripple="false" class="pa-0 ma-0" style="min-width: 20px" small flat @click="copyInfo('nr_statii_butoniera', n-1)">
                          <v-icon small left>mdi-plus-circle-multiple-outline</v-icon>
                          <span style="text-transform: none; max-width: 3.5em" class="text-truncate">{{entityObject.info_lift[n-2]['nr_statii_butoniera']}}</span>
                        </v-btn>
                      </div>
                    </v-system-bar>
                    <v-card-text class="pa-1">
                      <v-text-field
                        @input="setField($event, 'nr_statii_butoniera', 'info_lift', n-1, true)"
                        :value="entityObject.info_lift[n -1].nr_statii_butoniera"
                        type="number"
                        @wheel="onWheel"
                        hint="Nr statii butoniera."
                        persistent-hint
                        validate-on-blur
                        :rules="[val => ![null, ''].includes(val) || 'Camp obligatoriu!']"
                        solo flat
                        :disabled="user.dummy">
                      </v-text-field>
                    </v-card-text>
                  </v-card>

                  <v-card class="mb-3">
                    <v-system-bar window class="px-1">
                      <v-icon small color="error" style="margin-right: 0" @click="resetField('an_revizie', 'info_lift', n-1)">mdi-close</v-icon>

                      Anul ultimei revizii &nbsp;<span class="accent--text">lift {{n}}</span>
                      <v-btn class="pa-0 ma-0 ml-1" small flat icon v-if="isFieldEdited('an_revizie', 'info_lift', n-1)" @click="undo('an_revizie', 'info_lift', n-1)" :ripple="false">
                        <v-icon small>mdi-undo</v-icon>
                      </v-btn>
                      <v-spacer></v-spacer>
                      <div style="display: inline-flex; flex-grow: 1; flex-wrap: wrap; align-items: center" v-if="n-1">
                        <v-spacer></v-spacer>
                        <v-btn :ripple="false" class="pa-0 ma-0" style="min-width: 20px" small flat @click="copyInfo('an_revizie', n-1)">
                          <v-icon small left>mdi-plus-circle-multiple-outline</v-icon>
                          <span style="text-transform: none; max-width: 3.5em" class="text-truncate">{{entityObject.info_lift[n-2]['an_revizie']}}</span>
                        </v-btn>
                      </div>
                    </v-system-bar>
                    <v-card-text class="pa-1">
                      <v-radio-group
                        row
                        v-model="entityObject.info_lift[n -1].an_revizie"
                        hint="Anul utlimei revizii."
                        persistent-hint
                        :disabled="user.dummy">
                        <v-radio label="<2016" value="<2016" :ripple="false"></v-radio>
                        <v-radio label="2017" value="2017" :ripple="false"></v-radio>
                        <v-radio label="2018" value="2018" :ripple="false"></v-radio>
                        <v-radio label="2019" value="2019" :ripple="false"></v-radio>
                        <v-radio label="Nu exista info" value="Nu exista info" :ripple="false"></v-radio>
                      </v-radio-group>
                    </v-card-text>
                  </v-card>

                  <v-card class="mb-3">
                    <v-system-bar window class="px-1">
                      <v-icon small color="error" style="margin-right: 0" @click="resetField('an_next_revizie', 'info_lift', n-1)">mdi-close</v-icon>

                      Anul urm. revizii &nbsp;<span class="accent--text">lift {{n}}</span>
                      <v-btn class="pa-0 ma-0 ml-1" small flat icon v-if="isFieldEdited('an_next_revizie', 'info_lift', n-1)" @click="undo('an_next_revizie', 'info_lift', n-1)" :ripple="false">
                        <v-icon small>mdi-undo</v-icon>
                      </v-btn>
                      <v-spacer></v-spacer>
                      <div style="display: inline-flex; flex-grow: 1; flex-wrap: wrap; align-items: center" v-if="n-1">
                        <v-spacer></v-spacer>
                        <v-btn :ripple="false" class="pa-0 ma-0" style="min-width: 20px" small flat @click="copyInfo('an_next_revizie', n-1)">
                          <v-icon smal left>mdi-plus-circle-multiple-outline</v-icon>
                          <span style="text-transform: none; max-width: 3.5em" class="text-truncate">{{entityObject.info_lift[n-2]['an_next_revizie']}}</span>
                        </v-btn>
                      </div>
                    </v-system-bar>
                    <v-card-text class="pa-1">
                      <v-radio-group
                        row
                        v-model="entityObject.info_lift[n -1].an_next_revizie"
                        hint="Anul urmatoarei revizii."
                        persistent-hint
                        :disabled="user.dummy">
                        <v-radio label="2019" value="2019" :ripple="false"></v-radio>
                        <v-radio label="2020" value="2020" :ripple="false"></v-radio>
                        <v-radio label="2021" value="2021" :ripple="false"></v-radio>
                        <v-radio label="Nu exista info" value="Nu exista info" :ripple="false"></v-radio>
                      </v-radio-group>
                    </v-card-text>
                  </v-card>

                  <v-card class="mb-3">
                    <v-system-bar window class="px-1">
                      <v-icon small color="error" style="margin-right: 0" @click="resetField('luna_next_revizie', 'info_lift', n-1)">mdi-close</v-icon>

                      Luna urm. revizii &nbsp;<span class="accent--text">lift {{n}}</span>
                      <v-btn class="pa-0 ma-0 ml-1" small flat icon v-if="isFieldEdited('luna_next_revizie', 'info_lift', n-1)" @click="undo('luna_next_revizie', 'info_lift', n-1)" :ripple="false">
                        <v-icon small>mdi-undo</v-icon>
                      </v-btn>
                      <v-spacer></v-spacer>
                      <div style="display: inline-flex; flex-grow: 1; flex-wrap: wrap; align-items: center" v-if="n-1">
                        <v-spacer></v-spacer>
                        <v-btn :ripple="false" class="pa-0 ma-0" style="min-width: 20px" small flat @click="copyInfo('luna_next_revizie', n-1)">
                          <v-icon small left>mdi-plus-circle-multiple-outline</v-icon>
                          <span style="text-transform: none; max-width: 3.5em" class="text-truncate">{{entityObject.info_lift[n-2]['luna_next_revizie']}}</span>
                        </v-btn>
                      </div>
                    </v-system-bar>
                    <v-card-text class="pa-1">
                      <v-radio-group
                        row
                        v-model="entityObject.info_lift[n -1].luna_next_revizie"
                        hint="Luna urmatoarei revizii."
                        persistent-hint
                        :disabled="user.dummy">
                        <v-radio label="1" value="1" :ripple="false"></v-radio>
                        <v-radio label="2" value="2" :ripple="false"></v-radio>
                        <v-radio label="3" value="3" :ripple="false"></v-radio>
                        <v-radio label="4" value="4" :ripple="false"></v-radio>
                        <v-radio label="5" value="5" :ripple="false"></v-radio>
                        <v-radio label="6" value="6" :ripple="false"></v-radio>
                        <v-radio label="7" value="7" :ripple="false"></v-radio>
                        <v-radio label="8" value="8" :ripple="false"></v-radio>
                        <v-radio label="9" value="9" :ripple="false"></v-radio>
                        <v-radio label="10" value="10" :ripple="false"></v-radio>
                        <v-radio label="11" value="11" :ripple="false"></v-radio>
                        <v-radio label="12" value="12" :ripple="false"></v-radio>
                        <v-radio label="Nu exista info" value="Nu exista info" :ripple="false"></v-radio>
                      </v-radio-group>
                    </v-card-text>
                  </v-card>

                  <v-card class="mb-3">
                    <v-system-bar window class="px-1">
                      <v-icon small color="error" style="margin-right: 0" @click="resetField('lift_functional', 'info_lift', n-1)">mdi-close</v-icon>

                      Functional &nbsp;<span class="accent--text">lift {{n}}?</span>
                      <v-btn class="pa-0 ma-0 ml-1" small flat icon v-if="isFieldEdited('lift_functional', 'info_lift', n-1)" @click="undo('lift_functional', 'info_lift', n-1)" :ripple="false">
                        <v-spacer></v-spacer>
                        <v-icon small>mdi-undo</v-icon>
                      </v-btn>
                      <v-spacer></v-spacer>
                      <div style="display: inline-flex; flex-grow: 1; flex-wrap: wrap; align-items: center" v-if="n-1">
                        <v-spacer></v-spacer>
                        <v-btn :ripple="false" class="pa-0 ma-0" style="min-width: 20px" small flat @click="copyInfo('lift_functional', n-1)">
                          <v-icon small left>mdi-plus-circle-multiple-outline</v-icon>
                          <span style="text-transform: none; max-width: 3.5em" class="text-truncate">{{entityObject.info_lift[n-2]['lift_functional']}}</span>
                        </v-btn>
                      </div>
                    </v-system-bar>
                    <v-card-text class="pa-1">
                      <v-radio-group
                        row
                        v-model="entityObject.info_lift[n -1].lift_functional"
                        hint="Lift functional."
                        persistent-hint
                        :disabled="user.dummy">
                        <v-radio label="Da" value="Da" :ripple="false"></v-radio>
                        <v-radio label="Nu" value="Nu" :ripple="false"></v-radio>
                      </v-radio-group>
                    </v-card-text>
                  </v-card>

                  <v-card class="mb-3">
                    <form :ref="'formlift'+n">
                      <input type="file" :ref="'fileinputlift'+n" accept="image/*" multiple @change="filesAdded($event, `lift${n}`)" style="display: none">
                    </form>
                    <v-system-bar window class="px-1">
                      Poze &nbsp;<span class="accent--text">lift {{n}}</span> &nbsp;
                      <div style="display: inline-flex; flex-grow: 1; flex-wrap: wrap; align-items: center">
                        <template>
                          <v-icon class="ml-1" color="primary" title="Poze incarcate">mdi-camera</v-icon>
                          {{noOfLiftPhotos(n)}}
                        </template>
                        <template>
                          <v-btn class="ma-0 ml-1 pa-0" icon flat @click.stop.prevent style="min-width: 0" :ripple="false">
                            <v-icon :color="liftFilesInQueue(n) ? 'primary' : 'blue-grey'" class="mr-1" title="Poze in asteptare">mdi-cloud-upload</v-icon>
                            {{ liftFilesInQueue(n) }}
                          </v-btn>

                          <v-spacer></v-spacer>
                          <v-btn small class="ma-0" icon flat @click.stop.prevent="_cbAddPhoto(`lift${n}`)" v-if="user && !user.dummy" color="primary" :ripple="false">
                            <v-icon class="mr-0">mdi-plus-circle</v-icon>
                          </v-btn>

                          <!-- mark bad photos -->
                          <v-btn small class="ma-0" icon flat @click.stop.prevent="_cbToggleBadMode" v-if="!user.dummy" :ripple="false">
                            <v-icon :color="badEnabled ? 'warning' : 'blue-grey'" class="mr-0">mdi-alert</v-icon>
                          </v-btn>
                          <v-btn small class="ma-0" icon flat @click.stop.prevent="_cbConfirmBad" v-show="badEnabled && toBad.length" :ripple="false">
                            <v-icon color="warning" class="mr-0">mdi-check-circle</v-icon>
                          </v-btn>

                          <!-- mark delete photos -->

                          <v-btn small class="ma-0" icon flat @click.stop.prevent="_cbToggleDeleteMode" v-if="!user.dummy" :ripple="false">
                            <v-icon :color="deleteEnabled ? 'error' : 'blue-grey'" class="mr-0">mdi-delete-circle</v-icon>
                          </v-btn>
                          <v-btn small class="ma-0" icon flat @click.stop.prevent="_cbConfirmDelete" v-show="deleteEnabled && toDelete.length" :ripple="false">
                            <v-icon color="error" class="mr-0">mdi-check-circle</v-icon>
                          </v-btn>
                          <span v-show="deleteEnabled && toDelete.length">
                            {{toDelete.length}}
                          </span>

                        </template>
                      </div>
                    </v-system-bar>
                    <v-card-text class="pa-1">
                      <template v-if="noOfLiftPhotos(n)">
                        <viewer v-if="!deleteEnabled && !badEnabled" :options="{url: 'data-src', backdrop: 'static'}">
                          <template>
                            <v-layout align-center justify-flex-start wrap>
                              <div style="display: flex; flex-wrap: wrap">
                                <template v-for="(photo, pIndex) in liftPhotos(n)">
                                  <div style="display: flex; flex-direction: column; align-items: center; width: 64px" :key="photo + pIndex">
                                    <v-avatar
                                      size="48"
                                      class="ma-1 viewerPhoto"
                                      style="box-sizing: border-box">
                                      <img
                                        :src="serverURL + photo.replace('photos', 'thumbs')"
                                        :data-src="serverURL + photo"
                                        class="pa-1">
                                    </v-avatar>
                                    <div style="display: flex; justify-content: space-around; width: 100%">
                                      <a :href="serverURL + photo + '?buster=' + new Date().getTime()" download target="_blank" style="text-decoration: none" title="Descarca poza">
                                        <v-icon small>mdi-download</v-icon>
                                      </a>
                                      <v-icon small color="warning" v-if="photo.includes('_badphoto')">mdi-alert</v-icon>
                                      <a :href="serverURL + photo + '?buster=' + new Date().getTime()" target="_blank" style="text-decoration: none" title="Deschide poza intr-un tab nou">
                                        <v-icon small>mdi-eye</v-icon>
                                      </a>
                                    </div>
                                  </div>
                                </template>
                              </div>
                            </v-layout>
                          </template>
                        </viewer>
                        <v-layout v-if="deleteEnabled" align-center justify-flex-start wrap>
                          <!-- <v-scale-transition group> -->
                          <template v-for="(photo, pIndex) in liftPhotos(n)">
                            <div style="display: flex; flex-direction: column; align-items: center; width: 64px" :key="photo + pIndex">
                              <v-avatar
                                size="48"
                                class="ma-1"
                                :class="{ 'deletePhoto': toDelete.includes(photo), 'normalPhoto': !toDelete.includes(photo) }"
                                style="box-sizing: border-box"
                                @click="selectPhoto(photo)">
                                <img
                                  :src="serverURL + photo.replace('photos', 'thumbs')"
                                  :data-src="serverURL + photo"
                                  class="pa-1">
                              </v-avatar>
                              <v-icon small color="warning" v-if="photo.includes('_badphoto')">mdi-alert</v-icon>
                            </div>
                          </template>
                          <!-- </v-scale-transition> -->
                        </v-layout>
                        <v-layout v-if="badEnabled" align-center justify-flex-start wrap>
                          <!-- <v-scale-transition group> -->
                          <template v-for="(photo, pIndex) in liftPhotos(n)">
                            <div style="display: flex; flex-direction: column; align-items: center; width: 64px" :key="photo + pIndex">
                              <v-avatar
                                size="48"
                                class="ma-1"
                                :class="{ 'badPhoto': toBad.includes(photo), 'normalPhoto': !toBad.includes(photo) }"
                                style="box-sizing: border-box"
                                @click="selectBadPhoto(photo)">
                                <img
                                  :src="serverURL + photo.replace('photos', 'thumbs')"
                                  :data-src="serverURL + photo"
                                  class="pa-1">
                              </v-avatar>
                              <v-icon small color="warning" v-if="photo.includes('_badphoto')">mdi-alert</v-icon>
                            </div>
                          </template>
                          <!-- </v-scale-transition> -->
                        </v-layout>
                      </template>
                      <template v-else>
                        Nu exista poze pentru {{`lift ${n}`}}.
                      </template>
                    </v-card-text>
                  </v-card>

                  <v-card class="mb-3">
                    <form :ref="'pdfformlift' + n">
                      <input type="file" :ref="'pdffileinputlift' + n" accept="application/pdf" multiple @change="pdfsAdded($event, `lift${n}`)" style="display: none">
                    </form>
                    <v-system-bar window class="px-1">
                      PDF-uri &nbsp;<span class="accent--text">lift {{n}}</span> &nbsp;
                      <div style="display: inline-flex; flex-grow: 1; flex-wrap: wrap; align-items: center">
                        <template>
                          <v-icon class="ml-1" color="primary" title="Pdf-uri incarcate">mdi-file-pdf</v-icon>
                          {{noOfLiftPdfs(n)}}
                        </template>
                        <template>
                          <v-btn class="ma-0 ml-1 pa-0" icon flat @click.stop.prevent style="min-width: 0" :ripple="false">
                            <v-icon :color="liftPdfsInQueue(n) ? 'primary' : 'blue-grey'" class="mr-1" title="Pdf-uri in asteptare">mdi-cloud-upload</v-icon>
                            {{ liftPdfsInQueue(n) }}
                          </v-btn>

                          <v-spacer></v-spacer>
                          <v-btn class="ma-0" icon flat @click.stop.prevent="_cbAddPdf(`lift${n}`)" v-if="user && user.admin" color="primary" :ripple="false">
                            <v-icon>mdi-plus-circle</v-icon>
                          </v-btn>

                          <v-btn class="ma-0" icon flat @click.stop.prevent="_cbToggleDeletePdfsMode" v-if="user.admin" :ripple="false">
                            <v-icon :color="deletePdfsEnabled ? 'error' : 'blue-grey'">mdi-delete-circle</v-icon>
                          </v-btn>
                          <v-btn class="ma-0" icon flat @click.stop.prevent="_cbConfirmDeletePdfs" v-show="deletePdfsEnabled && toDeletePdfs.length" :ripple="false">
                            <v-icon color="error">mdi-check-circle</v-icon>
                          </v-btn>
                          <span v-show="deletePdfsEnabled && toDeletePdfs.length">
                            {{toDeletePdfs.length}}
                          </span>

                        </template>
                      </div>
                    </v-system-bar>
                    <v-card-text class="pa-1">
                      <template v-if="noOfLiftPdfs(n)">
                        <template v-if="!deletePdfsEnabled">
                          <v-layout align-center justify-flex-start wrap>
                            <div style="display: flex; flex-wrap: wrap">
                              <template v-for="(pdf, pIndex) in liftPdfs(n)">
                                <div style="display: flex; flex-direction: column; align-items: center; width: 64px" :key="pdf + pIndex">
                                  <v-avatar
                                    color="primary"
                                    size="48"
                                    class="ma-1"
                                    style="box-sizing: border-box">
                                    <v-icon class="pa-1">mdi-file-pdf</v-icon>
                                  </v-avatar>
                                  <span class="text-no-wrap text-truncate" style="width: 64px; text-align: center" :title="pdf">{{ pdf.replace('/pdfs/', '') }}</span>
                                  <div style="display: flex; justify-content: space-around; width: 100%">
                                    <a :href="serverURL + pdf + '?buster=' + new Date().getTime()" download target="_blank" style="text-decoration: none" title="Descarca pdf">
                                      <v-icon small>mdi-download</v-icon>
                                    </a>
                                    <a @click.stop="viewPdf(pdf, serverURL + pdf + '?buster=' + new Date().getTime())" style="text-decoration: none" title="Deschide pdf">
                                      <v-icon small>mdi-eye</v-icon>
                                    </a>
                                  </div>
                                </div>
                              </template>
                            </div>
                          </v-layout>
                        </template>
                        <template v-else>
                          <v-layout align-center justify-flex-start wrap>
                            <div style="display: flex; flex-wrap: wrap">
                              <template v-for="(pdf, pIndex) in liftPdfs(n)">
                                <div style="display: flex; flex-direction: column; align-items: center; width: 64px" :key="pdf + pIndex">
                                  <v-avatar
                                    :color="toDeletePdfs.includes(pdf) ? 'error' : ''"
                                    size="48"
                                    :key="pdf + pIndex"
                                    class="ma-1"
                                    :class="{ 'deletePdf': toDeletePdfs.includes(pdf), 'normalPdf': !toDeletePdfs.includes(pdf) }"
                                    style="box-sizing: border-box"
                                    @click="selectPdf(pdf)">
                                    <v-icon class="pa-1">
                                      mdi-file-pdf
                                    </v-icon>
                                  </v-avatar>
                                  <span :key="pdf + pIndex + 'pdf'" class="text-no-wrap text-truncate" style="width: 64px; text-align: center" :title="pdf">{{ pdf.replace('/pdfs/', '') }}</span>
                                </div>
                              </template>
                            </div>
                          </v-layout>
                        </template>
                      </template>
                      <template>
                        Nu exista pdf-uri pentru {{`lift ${n}`}}.
                      </template>
                    </v-card-text>
                  </v-card>
                </v-card-text>
              </v-card>
            </v-tab-item>
          </v-tabs>
        </v-card-text>
      </v-card>

      <v-dialog v-model="dialog" scrollable :transition="false" no-click-animation hide-overlay>
        <v-card>
          <v-card-title class="headline primary">
            Setari vizibilitate campuri
          </v-card-title>

          <v-card-text>
            <v-switch
              v-model="visibleFields"
              v-for="field in fields"
              :key="field"
              :label="field"
              :value="field"
              :ripple="false">
            </v-switch>
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="error" flat @click="_cbCloseSettings(0)" :ripple="false">
              Inchide
            </v-btn>
            <v-btn color="primary" flat @click="_cbCloseSettings(1)" :ripple="false">
              Salveaza
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="pdfDialog" fullscreen hide-overlay :transition="false" no-click-animation>
        <v-card>
          <v-toolbar dark color="primary">
            <v-btn icon dark @click="pdfDialog = false" :ripple="false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
            <v-toolbar-title>
              {{ pdfFrameTitle }}
            </v-toolbar-title>
          </v-toolbar>

          <v-card-text style="height: calc(100vh - 70px)" class="pa-0">
            <iframe :src="pdfFrameSrc" frameborder="0" width="100%" height="100%"></iframe>

            <!-- <embed :src="pdfFrameSrc" type="application/pdf" style="overflow: auto; width: 100%; height: 100%;"> -->
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-card-text>
  </v-card>
</template>

<script>
import 'viewerjs/dist/viewer.css'
import Viewer from 'v-viewer/src/component.vue'
// import { gmapApi } from 'vue2-google-maps'
import debounce from 'lodash.debounce'
import cloneDeep from 'lodash.clonedeep'
import uniqid from 'uniqid'

export default {
  components: {
    Viewer
  },
  name: 'entity-details',
  props: {
    entity: {
      type: String,
      required: true
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.$store.dispatch('entities/setActiveEntity', to.params.entity)
    })
  },
  beforeRouteLeave (to, from, next) {
    if (this.isEdited) {
      this.$dialog
        .confirm({
          title: 'Atentie!',
          body: 'Exista modificari nesalvate! Esti sigur(a) ca vrei sa parasesti pagina?'
        }, {
          okText: 'DA',
          cancelText: 'Nu, vreau sa raman!',
          animation: 'zoom'
        })
        .then(dialog => {
          this.$store.commit('entities/setActiveEntity', null)
          this.$store.commit('setIsDetailsEdited', false)
          next()
        })
        .catch(() => {
          next(false)
        })
    } else {
      this.$store.commit('entities/setActiveEntity', null)
      next()
    }
  },
  data: () => ({
    collapsed: false,
    fields: ['info adresa', 'info scara blocului', 'info consum', 'info lift'],
    entityObject: {
      __v: null,
      _id: null,
      addedBy: null,
      adresa: null,
      centru_geometric: { lat: 44.446086, lng: 26.063843 },
      createdAt: null,
      done: 'Nu',
      eticheta: null,
      zona: null,
      id_scara: null,
      info_consum: {
        exista_info: null,
        consum_curent_lift_avizier: null,
        consum_curent_lift_avizier_unitate_masura: null,
        consum_curent_spatii_comune_avizier: null,
        consum_curent_spatii_comune_avizier_unitate_masura: null
      },
      info_lift: [

      ],
      info_scara_blocului: {
        comert_servicii: null,
        etaj_tehnic_vizibil: null,
        nr_apartamente_pe_scara: null,
        nr_niveluri_comert_servicii: null,
        nr_niveluri_vizibile: null,
        reabilitat: null,
        regim_inaltime: 'P'
      },
      nr_lift_scara: null,
      observatii: null,
      observatii_adresa: null,
      pdfs: [],
      photos: [],
      updatedAt: null,
      user: null
    },
    deleteEnabled: false,
    toDelete: [],
    options: {
      width: '100%',
      height: '100%'
    },
    dialog: false,
    visibleFields: [],
    toDeletePdfs: [],
    deletePdfsEnabled: false,
    pdfDialog: false,
    pdfFrameSrc: '',
    pdfFrameTitle: '',
    badEnabled: false,
    toBad: []
  }),
  computed: {
    serverURL () {
      return this.$store.getters.serverURL
    },
    activeEntity () {
      return this.$store.getters['entities/activeEntity']
    },
    isEdited () {
      // return false
      return JSON.stringify(this.activeEntity) !== JSON.stringify(this.entityObject)
    },
    editedFields () {
      // return []
      // will have to refactor
      return this.fields.filter(field => {
        return JSON.stringify(this.activeEntity[field.value]) !== JSON.stringify(this.entityObject[field.value])
      }).map(field => field.value)
    },
    user () {
      return this.$store.getters.user
    },
    loading () {
      return this.$store.getters.loading
    },
    files () {
      return this.$store.getters['entities/files']
    },
    entityFilesInQueue () {
      return !this.activeEntity ? 0 : this.files.filter(file => file.entity === this.activeEntity._id && !file.uploaded && file.tip === 'photo' && file.parent === 'scara').length
    },
    entityPdfsInQueue () {
      return !this.activeEntity ? 0 : this.files.filter(file => file.entity === this.activeEntity._id && !file.uploaded && file.tip === 'pdf' && file.parent === 'scara').length
    },
    liftFilesInQueue () {
      return n => {
        return !this.activeEntity ? 0 : this.files.filter(file => file.entity === this.activeEntity._id && !file.uploaded && file.tip === 'photo' && file.parent === `lift${n}`).length
      }
    },
    liftPdfsInQueue () {
      return n => {
        return !this.activeEntity ? 0 : this.files.filter(file => file.entity === this.activeEntity._id && !file.uploaded && file.tip === 'pdf' && file.parent === `lift${n}`).length
      }
    },
    zoom () {
      return this.$store.getters.zoomDetailsPage
    },
    mapType () {
      return this.$store.getters.mapTypeDetailsPage
    },
    settings () {
      return this.$store.getters.settingsDetailsPage
    },
    labels () {
      return this.$store.getters['entities/labels']
    },
    zones () {
      return this.$store.getters['entities/zones']
    },
    noOfEntityPhotos () {
      return !this.activeEntity ? 0 : this.activeEntity.photos.reduce((acc, photo) => {
        if (photo.includes('_scara_')) acc = acc + 1
        return acc
      }, 0)
    },
    noOfEntityPdfs () {
      return !this.activeEntity ? 0 : this.activeEntity.pdfs.reduce((acc, pdf) => {
        if (pdf.includes('_scara_')) acc = acc + 1
        return acc
      }, 0)
    },
    scaraPhotos () {
      return !this.activeEntity ? [] : this.activeEntity.photos.filter(photo => photo.includes('scara'))
    },
    scaraPdfs () {
      return !this.activeEntity ? [] : this.activeEntity.pdfs.filter(pdf => pdf.includes('scara'))
    },
    noOfLiftPhotos () {
      return n => {
        return !this.activeEntity ? 0 : this.activeEntity.photos.reduce((acc, photo) => {
          if (photo.includes(`_lift${n}_`)) acc = acc + 1
          return acc
        }, 0)
      }
    },
    noOfLiftPdfs () {
      return n => {
        return !this.activeEntity ? 0 : this.activeEntity.pdfs.reduce((acc, pdf) => {
          if (pdf.includes(`_lift${n}_`)) acc = acc + 1
          return acc
        }, 0)
      }
    },
    liftPhotos () {
      return n => {
        return !this.activeEntity ? [] : this.activeEntity.photos.filter(photo => photo.includes(`lift${n}`))
      }
    },
    liftPdfs () {
      return n => {
        return !this.activeEntity ? [] : this.activeEntity.pdfs.filter(pdf => pdf.includes(`lift${n}`))
      }
    }
  },
  watch: {
    activeEntity: {
      deep: true,
      immediate: true,
      handler (obj) {
        // will have to refactor
        if (obj) {
          this.entityObject = Object.assign({}, cloneDeep(obj))
        } else {
          this.entityObject = Object.assign({}, {
            __v: null,
            _id: null,
            addedBy: null,
            adresa: null,
            centru_geometric: { lat: 44.446086, lng: 26.063843 },
            createdAt: null,
            done: 'Nu',
            eticheta: null,
            zona: null,
            id_scara: null,
            info_consum: {
              exista_info: null,
              consum_curent_lift_avizier: null,
              consum_curent_lift_avizier_unitate_masura: null,
              consum_curent_spatii_comune_avizier: null,
              consum_curent_spatii_comune_avizier_unitate_masura: null
            },
            info_lift: [

            ],
            info_scara_blocului: {
              comert_servicii: null,
              etaj_tehnic_vizibil: null,
              nr_apartamente_pe_scara: null,
              nr_niveluri_comert_servicii: null,
              nr_niveluri_vizibile: null,
              reabilitat: null,
              regim_inaltime: 'P'
            },
            nr_lift_scara: null,
            observatii: null,
            observatii_adresa: null,
            pdfs: [],
            photos: [],
            updatedAt: null,
            user: null
          })
        }
      }
    },
    settings: {
      immediate: true,
      deep: true,
      handler (val) {
        if (val) {
          if (typeof val === 'string') this.visibleFields = val.split(',')
          else if (Array.isArray(val)) this.visibleFields = val.slice()
        }
      }
    },
    'entityObject.info_scara_blocului.nr_niveluri_vizibile' (v) {
      this.computeRegimInaltime()
    },
    'entityObject.info_scara_blocului.etaj_tehnic_vizibil' (v) {
      this.computeRegimInaltime()
    },
    'entityObject.info_scara_blocului.comert_servicii' (v) {
      if (v === 'Nu') this.$set(this.entityObject.info_scara_blocului, 'nr_niveluri_comert_servicii', null)
      this.computeRegimInaltime()
    },
    'entityObject.info_scara_blocului.nr_niveluri_comert_servicii' (v) {
      this.computeRegimInaltime()
    },
    isEdited (v) {
      this.$store.commit('setIsDetailsEdited', v)
    },
    'entityObject.nr_lift_scara' (nv, ov) {
      this.updateInfoLift(nv, ov)
    }
  },
  methods: {
    selectPhoto (photo) {
      const index = this.toDelete.findIndex(p => p === photo)
      if (index > -1) {
        this.toDelete.splice(index, 1)
      } else {
        this.toDelete.push(photo)
      }
    },
    selectPdf (pdf) {
      const index = this.toDeletePdfs.findIndex(p => p === pdf)
      if (index > -1) {
        this.toDeletePdfs.splice(index, 1)
      } else {
        this.toDeletePdfs.push(pdf)
      }
    },
    _cbAddPhoto (type) {
      const ref = `fileinput${type}`
      if (Array.isArray(this.$refs[ref])) {
        this.$refs[ref][0].click()
      } else {
        this.$refs[ref].click()
      }
    },
    _cbConfirmDelete () {
      this.$dialog
        .confirm({
          title: 'Atentie!',
          body: 'Aceasta operatiune este definitiva!'
        }, {
          okText: 'OK',
          cancelText: 'Mmm, ma mai gandesc',
          animation: 'zoom'
        })
        .then(dialog => {
          this.$store.dispatch('entities/deletePhotos', { entity: this.activeEntity._id, photos: this.toDelete })
          this.toDelete = []
        })
        .catch(() => {
        })
    },
    _cbToggleDeleteMode () {
      this.deleteEnabled = !this.deleteEnabled
      this.toDelete = []

      this.badEnabled = false
      this.toBad = []
    },
    async filesAdded (e, parent) {
      let filesArray = Array.from(e.target.files)
      const ref = `form${parent}`

      this.$store.dispatch('entities/addFiles', { files: filesArray, entity: this.activeEntity._id, tip: 'photo', parent })
      if (Array.isArray(this.$refs[ref])) {
        this.$refs[ref][0].reset()
      } else {
        this.$refs[ref].reset()
      }
    },
    async pdfsAdded (e, parent) {
      let filesArray = Array.from(e.target.files)
      const ref = `pdfform${parent}`

      this.$store.dispatch('entities/addFiles', { files: filesArray, entity: this.activeEntity._id, tip: 'pdf', parent })
      if (Array.isArray(this.$refs[ref])) {
        this.$refs[ref][0].reset()
      } else {
        this.$refs[ref].reset()
      }
    },
    toggle () {
      this.collapsed = !this.collapsed
    },
    getType (fieldValue) {
      switch (fieldValue) {
        case 'eticheta': return 'select'
        case 'zona': return 'select'
        case 'done': return 'boolean'
        case 'id_scara': return 'text'
        case 'adresa': return 'textarea'
        case 'observatii_adresa': return 'textarea'
        case 'centru_geometric': return 'map'
        case 'regim_inaltime': return 'text' // special
        case 'nr_niveluri_vizibile': return 'number' // 3-18
        case 'etaj_tehnic_vizibil': return 'boolean' // da sau nu
        case 'comert_servicii': return 'boolean' // da sau nu
        case 'nr_niveluri_comert_servicii': return 'radio' // 1-3
        case 'reabilitat': return 'boolean' // da sau nu
        case 'nr_apartamente_pe_scara': return 'number' // min 1
        case 'consum_curent_lift_avizier': return 'number'
        case 'consum_curent_lift_avizier_unitate_masura': return 'radio'
        case 'consum_curent_spatii_comune_avizier': return 'number'
        case 'consum_curent_spatii_comune_avizier_unitate_masura': return 'radio'
        case 'nr_lift_scara': return 'radio' // 0, 1, 2, 3
        case 'tip_put': return 'radio' // beton sau metal
        case 'tip_deschidere_usa_put': return 'radio' // manuala, semiautomata, automata
        case 'capacitate_cabina_persoane': return 'number'
        case 'capacitate_cabina_masa': return 'number'
        case 'stare_cabina': return 'radio' // veche sau placata/schimbata
        case 'nr_statii_butoniera': return 'number'
        case 'an_revizie': return 'radio' // <2016, 2017, 2018 sau 2019
        case 'lift_functional': return 'boolean' // da sau nu
        case 'observatii': return 'textarea'
        default: return false
      }
    },
    getMin (fieldValue) {
      switch (fieldValue) {
        case 'nr_niveluri_vizibile': return 3
        // case 'nr_niveluri_comert_servicii': return 1
        case 'nr_apartamente_pe_scara': return 1
        // case 'nr_lift_scara': return 0
      }
    },
    getMax (fieldValue) {
      switch (fieldValue) {
        case 'nr_niveluri_vizibile': return 18
        // case 'nr_niveluri_comert_servicii': return 3
        case 'nr_apartamente_pe_scara': return 999
        // case 'nr_lift_scara': return 3
      }
    },
    getOptions (fieldValue) {
      switch (fieldValue) {
        case 'consum_curent_lift_avizier_unitate_masura': return ['lei', 'kWh/luna']
        case 'consum_curent_spatii_comune_avizier_unitate_masura': return ['lei', 'kWh/luna']
        case 'tip_put': return ['beton', 'metal']
        case 'tip_deschidere_usa_put': return ['manuala', 'semiautomata', 'automata']
        case 'stare_cabina': return ['veche', 'placata/schimbata']
        case 'an_revizie': return ['<2016', '2017', '2018', '2019']
        case 'done': return ['Da', 'Nu']
        case 'etaj_tehnic_vizibil': return ['Da', 'Nu']
        case 'comert_servicii': return ['Da', 'Nu']
        case 'reabilitat': return ['Da', 'Nu']
        case 'lift_functional': return ['Da', 'Nu']
        case 'nr_niveluri_comert_servicii': return [1, 2, 3]
        case 'nr_lift_scara': return [0, 1, 2, 3]
      }
    },
    getRules (fieldValue) {
      switch (fieldValue) {
        case 'id_scara':
        case 'adresa':
        case 'centru_geometric':
        case 'regim_inaltime':
        case 'nr_niveluri_vizibile':
        case 'etaj_tehnic_vizibil':
        case 'comert_servicii':
        case 'reabilitat':
        case 'nr_apartamente_pe_scara':
        case 'consum_curent_lift_spatii_comune_avizier':
        case 'consum_curent_lift_spatii_comune_avizier_unitate_masura':
        case 'consum_curent_lift_spatii_comune_avizier_aplicabilitate':
        case 'nr_lift_scara':
        case 'tip_put':
        case 'tip_deschidere_usa_put':
        case 'capacitate_cabina_persoane':
        case 'capacitate_cabina_masa':
        case 'stare_cabina':
        case 'nr_statii_butoniera':
        case 'an_revizie':
        case 'lift_functional':
        case 'eticheta': return [val => val === null ? 'Camp obligatoriu' : true]
        case 'zona': return [val => val === null ? 'Camp obligatoriu' : true]
        case 'nr_niveluri_comert_servicii': return this.entityObject.comert_servicii ? [val => val === null ? 'Camp obligatoriu' : true] : []
        default: return []
      }
    },
    computeRegimInaltime: debounce(function () {
      let str = 'P'
      if (this.entityObject.info_scara_blocului.comert_servicii) {
        if (this.entityObject.info_scara_blocului.nr_niveluri_comert_servicii > 1) { // 1-3
          if (this.entityObject.info_scara_blocului.nr_niveluri_comert_servicii === 2) { // 1-3
            str += '+M'
          } else {
            str += '+2M'
          }
        }
      }

      if (this.entityObject.info_scara_blocului.nr_niveluri_vizibile) {
        str += `+${this.entityObject.info_scara_blocului.nr_niveluri_vizibile}E`
      }

      if (this.entityObject.info_scara_blocului.etaj_tehnic_vizibil === 'Da') {
        str += '+Eth'
      }

      this.$set(this.entityObject.info_scara_blocului, 'regim_inaltime', str)
    }, 1000),
    save () {
      this.entityObject.user = this.user.username
      this.$store.dispatch('entities/save', this.entityObject)
    },

    zoomChanged: debounce(function ($event) {
      this.$store.commit('setZoomDetailsPage', $event)
    }, 1000),
    mapTypeChanged ($event) {
      this.$store.commit('setMapTypeDetailsPage', $event)
    },

    _cbDragEnd: debounce(function ($event) {
      if (!this.user.dummy) {
        this.$dialog
          .confirm({
            title: 'Atentie!',
            body: 'Ai miscat pin-ul pe harta. Esti sigur ca vrei sa modifici coordonatele?'
          }, {
            okText: 'DA, modific!',
            cancelText: 'Nu, nu modific.',
            animation: 'zoom'
          })
          .then(dialog => {
            this.$set(this.entityObject, 'centru_geometric', { lat: $event.latLng.lat(), lng: $event.latLng.lng() })
          })
          .catch(() => {
            this.$set(this.entityObject, 'centru_geometric', { lat: this.entityObject.centru_geometric.lat, lng: this.entityObject.centru_geometric.lng })
          })
      }
    }, 1000),

    undo (field, parent = null, index = null) {
      if (field === 'nr_lift_scara') {
        this.entityObject.info_lift = this.activeEntity.info_lift.map(lift => cloneDeep(lift))
      }

      if (field === 'centru_geometric') {
        this.entityObject.centru_geometric.lat = this.activeEntity.centru_geometric.lat
        this.entityObject.centru_geometric.lng = this.activeEntity.centru_geometric.lng
      } else {
        if (!parent) {
          this.$set(this.entityObject, field, this.activeEntity[field])
        } else {
          if (index !== null) {
            if (this.activeEntity[parent][index]) {
              this.$set(this.entityObject[parent][index], field, this.activeEntity[parent][index][field])
            } else {
              this.$set(this.entityObject[parent][index], field, null)
            }
          } else {
            this.$set(this.entityObject[parent], field, this.activeEntity[parent][field])
          }
        }
      }
    },

    _cbUndoAll () {
      this.entityObject = Object.assign({}, cloneDeep(this.activeEntity))
    },

    _cbOpenSettings () {
      this.dialog = true
    },
    _cbCloseSettings (mode) {
      if (mode) {
        this.dialog = false
        this.$store.commit('setSettingsDetailsPage', this.visibleFields)
      } else {
        this.dialog = false
      }
    },

    _cbAddPdf (type) {
      const ref = `pdffileinput${type}`
      if (Array.isArray(this.$refs[ref])) {
        this.$refs[ref][0].click()
      } else {
        this.$refs[ref].click()
      }
    },
    _cbToggleDeletePdfsMode () {
      this.deletePdfsEnabled = !this.deletePdfsEnabled
      this.toDeletePdfs = []
    },
    _cbConfirmDeletePdfs () {
      this.$dialog
        .confirm({
          title: 'Atentie!',
          body: 'Aceasta operatiune este definitiva?'
        }, {
          okText: 'OK',
          cancelText: 'Mmm, ma mai gandesc',
          animation: 'zoom'
        })
        .then(dialog => {
          this.$store.dispatch('entities/deletePdfs', { entity: this.activeEntity._id, pdfs: this.toDeletePdfs })
          this.toDeletePdfs = []
        })
        .catch(() => {
        })
    },
    viewPdf (pdf, src) {
      this.pdfFrameSrc = src
      this.pdfFrameTitle = pdf.replace('/pdfs/', '')
      this.pdfDialog = true
    },
    onWheel ($event) {
      if ($event.target.type === 'number') {
        $event.target.blur()
      }
    },
    refreshIdScara () {
      if (this.user.admin) {
        this.entityObject.id_scara = uniqid()
      }
    },
    isFieldEdited (field, parent = null, index = null) {
      // return false
      if (this.activeEntity) {
        if (parent) {
          if (index !== null) {
            // eslint-disable-next-line
            if (!this.activeEntity[parent][index]) return this.entityObject[parent][index][field] === null ? false : true
            return this.activeEntity[parent][index][field] !== this.entityObject[parent][index][field]
          } else {
            return this.activeEntity[parent][field] !== this.entityObject[parent][field]
          }
        } else {
          if (field === 'centru_geometric') {
            return this.activeEntity[field].lat !== this.entityObject[field].lat || this.activeEntity[field].lng !== this.entityObject[field].lng
          } else {
            return this.activeEntity[field] !== this.entityObject[field]
          }
        }
      }
      return false
    },
    etichetaText (item) {
      return `${item.label} - ${item.data}`
    },
    zonaText (item) {
      return `${item.zona}`
    },
    updateInfoLift (newVal, oldVal) {
      if (newVal === 0 || newVal === null) {
        this.$set(this.entityObject, 'info_lift', [
          {
            tip_put: null,
            tip_deschidere_usa_put: null,
            exista_info_capacitate: null,
            capacitate_cabina_persoane: null,
            capacitate_cabina_kg: null,
            stare_cabina: null,
            nr_statii_butoniera: null,
            an_revizie: null,
            an_next_revizie: null,
            luna_next_revizie: null,
            lift_functional: null
          },
          {
            tip_put: null,
            tip_deschidere_usa_put: null,
            exista_info_capacitate: null,
            capacitate_cabina_persoane: null,
            capacitate_cabina_kg: null,
            stare_cabina: null,
            nr_statii_butoniera: null,
            an_revizie: null,
            an_next_revizie: null,
            luna_next_revizie: null,
            lift_functional: null
          },
          {
            tip_put: null,
            tip_deschidere_usa_put: null,
            exista_info_capacitate: null,
            capacitate_cabina_persoane: null,
            capacitate_cabina_kg: null,
            stare_cabina: null,
            nr_statii_butoniera: null,
            an_revizie: null,
            an_next_revizie: null,
            luna_next_revizie: null,
            lift_functional: null
          }
        ])
      } else {
        // 1 -> 0 -> 0
        // 2 -> 0 -> 0, 1
        // 3 -> 0 -> 0, 1, 2
        // 2 -> 1 -> 1
        // 3 -> 1 -> 1, 2
        // 3 -> 2 -> 2

        // console.log(newVal, oldVal)

        for (let i = newVal; i < oldVal; i++) {
          Object.keys(this.entityObject.info_lift[i]).forEach(key => {
            this.$set(this.entityObject.info_lift[i], key, null)
          })
        }
      }

      this.$set(this.entityObject, 'nr_lift_scara', newVal)
    },
    setField ($value, field, parent = null, index = null, number = false) {
      if (parent) {
        if (index === null) {
          this[`set_${field}_${parent}`](number ? (isNaN($value) ? null : +$value) : $value)
        } else {
          this[`set_${field}_${parent}_${index}`](number ? (isNaN($value) ? null : +$value) : $value)
        }
      } else {
        this[`set_${field}`](number ? (isNaN($value) ? null : +$value) : $value)
      }
    },

    set_id_scara: debounce(function (value) {
      this.$set(this.entityObject, 'id_scara', value)
    }, 1000),
    set_adresa: debounce(function (value) {
      this.$set(this.entityObject, 'adresa', value)
    }, 1000),
    set_observatii_adresa: debounce(function (value) {
      this.$set(this.entityObject, 'observatii_adresa', value)
    }, 1000),
    set_observatii: debounce(function (value) {
      this.$set(this.entityObject, 'observatii', value)
    }, 1000),
    set_nr_apartamente_pe_scara_info_scara_blocului: debounce(function (value) {
      this.$set(this.entityObject.info_scara_blocului, 'nr_apartamente_pe_scara', value)
    }, 1000),
    set_nr_niveluri_vizibile_info_scara_blocului: debounce(function (value) {
      this.$set(this.entityObject.info_scara_blocului, 'nr_niveluri_vizibile', value)
    }, 1000),
    set_consum_curent_lift_avizier_info_consum: debounce(function (value) {
      this.$set(this.entityObject.info_consum, 'consum_curent_lift_avizier', value)
    }, 1000),
    set_consum_curent_spatii_comune_avizier_info_consum: debounce(function (value) {
      this.$set(this.entityObject.info_consum, 'consum_curent_spatii_comune_avizier', value)
    }, 1000),
    set_capacitate_cabina_persoane_info_lift_0: debounce(function (value) {
      this.$set(this.entityObject.info_lift[0], 'capacitate_cabina_persoane', value)
    }, 1000),
    set_capacitate_cabina_kg_info_lift_0: debounce(function (value) {
      this.$set(this.entityObject.info_lift[0], 'capacitate_cabina_kg', value)
    }, 1000),
    set_nr_statii_butoniera_info_lift_0: debounce(function (value) {
      this.$set(this.entityObject.info_lift[0], 'nr_statii_butoniera', value)
    }, 1000),
    set_capacitate_cabina_persoane_info_lift_1: debounce(function (value) {
      this.$set(this.entityObject.info_lift[1], 'capacitate_cabina_persoane', value)
    }, 1000),
    set_capacitate_cabina_kg_info_lift_1: debounce(function (value) {
      this.$set(this.entityObject.info_lift[1], 'capacitate_cabina_kg', value)
    }, 1000),
    set_nr_statii_butoniera_info_lift_1: debounce(function (value) {
      this.$set(this.entityObject.info_lift[1], 'nr_statii_butoniera', value)
    }, 1000),
    set_capacitate_cabina_persoane_info_lift_2: debounce(function (value) {
      this.$set(this.entityObject.info_lift[2], 'capacitate_cabina_persoane', value)
    }, 1000),
    set_capacitate_cabina_kg_info_lift_2: debounce(function (value) {
      this.$set(this.entityObject.info_lift[2], 'capacitate_cabina_kg', value)
    }, 1000),
    set_nr_statii_butoniera_info_lift_2: debounce(function (value) {
      this.$set(this.entityObject.info_lift[2], 'nr_statii_butoniera', value)
    }, 1000),

    copyInfo (field, index) {
      this.$set(this.entityObject.info_lift[index], field, this.entityObject.info_lift[index - 1][field])
    },

    resetField (field, parent = null, index = null) {
      if (parent) {
        if (index !== null) {
          this.$set(this.entityObject[parent][index], field, null)
        } else {
          this.$set(this.entityObject[parent], field, null)
        }
      } else {
        if (field !== 'centru_geometric') {
          this.$set(this.entityObject, field, field === 'done' ? false : null)
        }
      }
    },

    _cbResetAll () {
      const fields = [
        { field: 'observatii_adresa', parent: null, index: null },
        { field: 'observatii', parent: null, index: null },
        { field: 'done', parent: null, index: null },
        { field: 'nr_lift_scara', parent: null, index: null },

        { field: 'comert_servicii', parent: 'info_scara_blocului', index: null },
        { field: 'etaj_tehnic_vizibil', parent: 'info_scara_blocului', index: null },
        { field: 'nr_apartamente_pe_scara', parent: 'info_scara_blocului', index: null },
        { field: 'nr_niveluri_comert_servicii', parent: 'info_scara_blocului', index: null },
        { field: 'nr_niveluri_vizibile', parent: 'info_scara_blocului', index: null },
        { field: 'reabilitat', parent: 'info_scara_blocului', index: null },

        { field: 'consum_curent_lift_avizier', parent: 'info_consum', index: null },
        { field: 'consum_curent_lift_avizier_unitate_masura', parent: 'info_consum', index: null },
        { field: 'consum_curent_spatii_comune_avizier', parent: 'info_consum', index: null },
        { field: 'consum_curent_spatii_comune_avizier_unitate_masura', parent: 'info_consum', index: null },
        { field: 'exista_info', parent: 'info_consum', index: null },

        { field: 'an_next_revizie', parent: 'info_lift', index: 0 },
        { field: 'an_revizie', parent: 'info_lift', index: 0 },
        { field: 'capacitate_cabina_kg', parent: 'info_lift', index: 0 },
        { field: 'capacitate_cabina_persoane', parent: 'info_lift', index: 0 },
        { field: 'exista_info_capacitate', parent: 'info_lift', index: 0 },
        { field: 'lift_functional', parent: 'info_lift', index: 0 },
        { field: 'luna_next_revizie', parent: 'info_lift', index: 0 },
        { field: 'nr_statii_butoniera', parent: 'info_lift', index: 0 },
        { field: 'stare_cabina', parent: 'info_lift', index: 0 },
        { field: 'tip_deschidere_usa_put', parent: 'info_lift', index: 0 },
        { field: 'tip_put', parent: 'info_lift', index: 0 },

        { field: 'an_next_revizie', parent: 'info_lift', index: 1 },
        { field: 'an_revizie', parent: 'info_lift', index: 1 },
        { field: 'capacitate_cabina_kg', parent: 'info_lift', index: 1 },
        { field: 'capacitate_cabina_persoane', parent: 'info_lift', index: 1 },
        { field: 'exista_info_capacitate', parent: 'info_lift', index: 1 },
        { field: 'lift_functional', parent: 'info_lift', index: 1 },
        { field: 'luna_next_revizie', parent: 'info_lift', index: 1 },
        { field: 'nr_statii_butoniera', parent: 'info_lift', index: 1 },
        { field: 'stare_cabina', parent: 'info_lift', index: 1 },
        { field: 'tip_deschidere_usa_put', parent: 'info_lift', index: 1 },
        { field: 'tip_put', parent: 'info_lift', index: 1 },

        { field: 'an_next_revizie', parent: 'info_lift', index: 2 },
        { field: 'an_revizie', parent: 'info_lift', index: 2 },
        { field: 'capacitate_cabina_kg', parent: 'info_lift', index: 2 },
        { field: 'capacitate_cabina_persoane', parent: 'info_lift', index: 2 },
        { field: 'exista_info_capacitate', parent: 'info_lift', index: 2 },
        { field: 'lift_functional', parent: 'info_lift', index: 2 },
        { field: 'luna_next_revizie', parent: 'info_lift', index: 2 },
        { field: 'nr_statii_butoniera', parent: 'info_lift', index: 2 },
        { field: 'stare_cabina', parent: 'info_lift', index: 2 },
        { field: 'tip_deschidere_usa_put', parent: 'info_lift', index: 2 },
        { field: 'tip_put', parent: 'info_lift', index: 2 }
      ]

      this.$dialog
        .confirm({
          title: 'Atentie!',
          body: 'Esti pe cale sa stergi toate informatiile editabile ale simbolului! Esti sigur ca doresti sa faci asta?'
        }, {
          okText: 'DA',
          cancelText: 'Nu',
          animation: 'zoom'
        })
        .then(dialog => {
          fields.forEach(field => {
            this.resetField(field.field, field.parent, field.index)
          })
        })
        .catch(() => {
        })
    },

    _cbConfirmBad () {
      this.$dialog
        .confirm({
          title: 'Atentie!',
          body: 'Aceasta operatiune este reversibila!'
        }, {
          okText: 'OK',
          cancelText: 'Mmm, ma mai gandesc',
          animation: 'zoom'
        })
        .then(dialog => {
          this.$store.dispatch('entities/badPhotos', { entity: this.activeEntity._id, photos: this.toBad })
          this.toBad = []
          this.badEnabled = false
        })
        .catch(() => {
        })
    },
    _cbToggleBadMode () {
      this.badEnabled = !this.badEnabled
      this.toBad = []
      this.deleteEnabled = false
      this.toDelete = []
    },
    selectBadPhoto (photo) {
      const index = this.toBad.findIndex(p => p === photo)
      if (index > -1) {
        this.toBad.splice(index, 1)
      } else {
        this.toBad.push(photo)
      }
    }
  }
}
</script>

<style lang="stylus">

</style>
